enum TrackedEventProcessEnum {
    SubscriptionActivationProcess = 'SubscriptionActivationProcess',
    Default = 'Default',
    SubscriptionBillingProcess = 'SubscriptionBillingProcess'
}

export default TrackedEventProcessEnum;
